export const getJaNein = (arg: boolean | undefined | null): string => {
  if (!arg) return "unknown"
  return arg ? "yes" : "no"
}
